// Alur status servis (TERKUNCI, 6 langkah) + izin transisi. Fungsi murni.
import type { TicketStatus, Role } from '@core/types';

export const FLOW: readonly TicketStatus[] = [
  'Diterima', 'Diagnosa', 'Menunggu Persetujuan',
  'Dikerjakan', 'Siap Diambil', 'Sudah Diambil',
] as const;

/**
 * Tiket masih berjalan = unit fisiknya sedang ada urusan servis. Dipakai untuk mencegah satu
 * unit punya DUA tiket sekaligus (mis. tombol "Servis Lagi (Garansi)" ditekan dua kali).
 * Tiket terarsip tidak dihitung — kalau dihitung, unitnya terkunci selamanya.
 */
export const masihBerjalan = (status: string, archived: boolean): boolean =>
  !archived && status !== 'Sudah Diambil';

export function nextOf(s: TicketStatus): TicketStatus | null {
  const i = FLOW.indexOf(s);
  return i >= 0 && i < FLOW.length - 1 ? FLOW[i + 1]! : null;
}

/** Siapa boleh memajukan status tertentu (diport dari prototype canAdvance). */
export function canAdvance(status: TicketStatus, role: Role, isOwnTicket: boolean): boolean {
  const mgr = role === 'Owner' || role === 'Manager' || role === 'SPV';
  switch (status) {
    case 'Diterima': return mgr;
    case 'Diagnosa': return mgr || (role === 'Teknisi' && isOwnTicket);
    case 'Menunggu Persetujuan': return mgr || role === 'CS';
    case 'Dikerjakan': return mgr || (role === 'Teknisi' && isOwnTicket);
    case 'Siap Diambil': return mgr || role === 'CS';
    default: return false;
  }
}
